module.exports = __webpack_public_path__ + "img/info_bg3.ccec92b6.png";